module.exports = __webpack_public_path__ + "img/Finale1.ed6102a0.jpg";